export { default } from "./ActivityDetail";

